import React, { ReactNode } from 'react';
import { Stack } from '@mui/material';

import { TableActions } from '@/components';
import { ToolbarActions } from '@/core';

export const TableHeaderLayout = ({
  selectedRows,
  onDelete,
  onDuplicate,
  onDeactivate,
  onActivate,
  onCancel,
  actions,
  children,
  isDuplicateDisabled,
}: {
  selectedRows: number[];
  onDelete: () => void;
  onDuplicate: () => void;
  onDeactivate: () => void;
  onActivate: () => void;
  onCancel: () => void;
  children: ReactNode;
  actions: ToolbarActions;
  isDuplicateDisabled?: boolean;
}) => {
  return (
    <Stack sx={{ width: '100%', padding: '0 26px' }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ my: 2, width: '100%' }}
      >
        {children}
      </Stack>
      {selectedRows.length > 0 && (
        <TableActions
          selectedRows={selectedRows.length}
          onDelete={onDelete}
          onDuplicate={onDuplicate}
          onDeactivate={onDeactivate}
          onActivate={onActivate}
          onCancel={onCancel}
          actions={actions}
          isDuplicateDisabled={isDuplicateDisabled}
        />
      )}
    </Stack>
  );
};
